import React from 'react';
import './App.css';
import './styles/CalculatorContainer.css';

import CalculatorContainer from './containers/CalculatorContainer';

function App() {
  return (
    <div>
      <CalculatorContainer></CalculatorContainer>
    </div>
  );
}

export default App;
